<template>
  <div>
    <!-- 新建客户 :title="customerId?'修改客户':'新增客户'" -->
    <el-dialog class="addUser" title="新增客户" :visible.sync="adddialog" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false" width="720px">
      <el-form :model="addform" :rules="rules" ref="addform">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
                <el-input v-model="addform.name" autocomplete="off" size="mini"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
                <el-input v-model="addform.phone" autocomplete="off" size="mini"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="性别" :label-width="formLabelWidth">
                <el-radio v-model="addform.gender" :label="2">女</el-radio>
                <el-radio v-model="addform.gender" :label="1">男</el-radio>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="来源" :label-width="formLabelWidth" prop="origin">
                <el-select v-model="addform.origin" filterable clearable placeholder="请选择" size="mini" style="width:100%;">
                  <el-option v-for="item in sourceoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="省市区" :label-width="formLabelWidth" prop="selectedOptions">
                <el-cascader style="width:100%;" :options="options" v-model="addform.selectedOptions" @change="addressChoose" size="mini"></el-cascader>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="地址详情" :label-width="formLabelWidth">
                <el-input v-model="addform.street" autocomplete="off" size="mini"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <el-form-item label="备注" :label-width="formLabelWidth">
                <el-input v-model="addform.remarks" type="textarea" :rows="2" placeholder="请输入备注" size="mini"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetaddForm('addform')" size="mini">取消</el-button>
        <el-button type="primary" @click="submitaddForm('addform')" size="mini">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新建客户end -->
  </div>
</template>

<script>
import { createCustomer,customerDetail,createEdit} from '@/api/api.js'
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  name: 'CreateCustomer',
  data() {
    return {
      adddialog:true,
      formLabelWidth: '120px',
      sourceoptions:[
        {value: '客户推荐',label: '客户推荐'},
      ],
      options: regionDataPlus,
      addform:{
        name:'',
        phone:'',
        selectedOptions: [],
        province:'',
        city:'',
        area:'',
        origin:'',
        street:'',
        gender:'',
        remarks:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],  
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[1-9][0-9]\d{8}$/,message: '请输入正确的手机号',trigger: 'blur'}
        ],
        selectedOptions: [
          { required: true, message: '请选择省', trigger: 'change' }
        ],
        origin: [
          { required: true, message: '请选择来源', trigger: 'change' }
        ],
      },//新增客户end
      customerDel:{
        name:'',
        phone:'',
        selectedOptions: [],
        province:'',
        city:'',
        area:'',
        address:'',
        gender:'',
        origin:'',
        remarks:''
      },
    };
  },
  props:['adddialogFather','customerId'],
  created() {
    // if(this.customerId){
    //   this.getcustomerDetail()
    // }
  },
  mounted() {
  },
  methods: {
    addressChoose(value) {
        // console.log("省市区：",CodeToText[value[0]],CodeToText[value[1]],CodeToText[value[2]]);
        this.addform.province = CodeToText[value[0]];
        this.addform.city = CodeToText[value[1]];
        this.addform.area = CodeToText[value[2]];
    },
    //新建客户
    submitaddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if(this.customerId){
          //   //编辑
          //   this.addform.id=this.customerId;
          //   let parmas = this.addform;
          //   createEdit(parmas).then(res => {
          //     if(res.data.code==200){
          //       this.$message({ duration: 2000,showClose: true,message: '修改客户成功',type: 'success' });
          //       this.$refs[formName].resetFields();
          //       this.$emit("chooseData")
          //     }else{
          //       this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          //     }
          //   });
          // }else{
            //添加
            let parmas = this.addform;
            createCustomer(parmas).then(res => {
              if(res.data.code==200){
                this.$message({ duration: 2000,showClose: true,message: '新建客户成功',type: 'success' });
                this.$refs[formName].resetFields();
                this.$emit("chooseData")
              }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
              }
            });
          // }
        } else {
          return false;
        }
      });
    },
    resetaddForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('chooseData');
    },
    handleClose(){
      this.$emit('chooseData');
    },
    //新建客户end

    //客户详情
    getcustomerDetail() {
        customerDetail({customerId:this.customerId}).then(res => {
            if(res.data.code==200){
              this.addform.selectedOptions=[];
              this.customerDel=res.data.data;
              this.addform.name=this.customerDel.name,
              this.addform.phone=this.customerDel.phone,
              this.addform.province=this.customerDel.province,
              this.addform.city=this.customerDel.city,
              this.addform.area=this.customerDel.area,
              this.addform.street=this.customerDel.address;
              this.addform.gender=this.customerDel.gender;
              this.addform.origin=this.customerDel.origin;
              this.addform.remarks=this.customerDel.remarks;

              let province = this.customerDel.province;
              let city = this.customerDel.city;
              let area = this.customerDel.area;
              let arg1 = province?TextToCode[province].code:'';
              let arg2 = city?TextToCode[province][city].code:'';
              let arg3 = area?TextToCode[province][city][area].code:'';
              this.addform.selectedOptions.push(arg1,arg2,arg3);
            }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
        });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/createCustomer.vue